import axios from 'axios'
import { API } from "./api";
import { getTokenStorage, removeToken, getLangType } from "./function"
import { message } from "antd";

axios.defaults.baseURL = API.BASEURL;
let ajaxLoading = document.getElementById('ajaxLoading')

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
export class Axios {

    static ajax(options) {
        if (!options.closeLoading) {
            ajaxLoading.style.display = 'block'
        }
        return new Promise((resolve, reject) => {
            axios({
                method: options.method ? options.method : 'get',
                url: options.url,
                data: options.data || "",
                responseType: options.responseType,
                headers: {
                    'Authorization': getTokenStorage() && !!!options.noToken ? "Bearer " + getTokenStorage() : "",
                    "Language-Id": getLangType()
                },
            }).then(res => {
                ajaxLoading.style.display = 'none'
                if (options.tips) {
                    message.success(options.tips)
                }
                resolve(res)
            }).catch(e => {
                if (e.response && e.response.data.message === "token无效...") {
                    removeToken()
                    window.location.href = '#/login'
                } else if (e.response && e.response.data && e.response.data.message) {
                    message.error(e.response.data.message)
                }
                if (!options.closeLoading) {
                    ajaxLoading.style.display = 'none'
                }
                reject(e)
            })
        })

    }


}



// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        if (error.response && error.response.data.message === "token无效...") {
            removeToken()
            window.location.href = '#/login'
        }

        if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.phone) {
            message.error("The mobile phone number has been used, please change it .")
        }

        if (error.response && error.response.status === 500) {
            // window.location.href = '#/login'
            // message.error("登录错误")
            return Promise.reject(error)
        }
        // 对响应错误做点什么

        return Promise.reject(error)
    }
)

